import React from 'react';
import Modal from './Modal';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, isDangerous = false }) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onCancel}
      footer={
        <div style={{ display: 'flex', gap: '12px' }}>
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            className={isDangerous ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={() => {
              onConfirm();
              onCancel();
            }}
          >
            Confirm
          </button>
        </div>
      }
    >
      <p style={{ marginBottom: '20px', fontSize: '14px', color: '#7f8c8d' }}>
        {message}
      </p>
    </Modal>
  );
};

export default ConfirmDialog;
